// @LastEditors: Jacky
// @LastEditTime: 2023-07-25 15:16:23
// @FilePath: /pool-interface/src/components/Text/index.tsx
// Copyright (c) 2023 by Jacky, All Rights Reserved.
import styled from 'styled-components/macro'

interface TextProps {
  color?: string
  fontSize?: string
  bold?: boolean
  small?: boolean
  ellipsis?: boolean
  lines?: number
  fontWeight?: string | number
  textTransform?: 'uppercase' | 'lowercase' | 'capitalize'
  margin?: string
}

const Text = styled.div<TextProps>`
  color: ${({ color }) => color ?? '#000'};
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '16px')};
  font-weight: ${({ bold, fontWeight }) => (fontWeight ? fontWeight : bold ? 600 : 400)};
  line-height: 1.5;
  font-family: 'mojitofont';
  margin: ${({ margin }) => margin ?? '0px'};
  ${({ textTransform }) => textTransform && `text-transform: ${textTransform};`}
  ${({ ellipsis }) =>
    ellipsis &&
    `white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;`}

  ${({ lines }) =>
    `-webkit-line-clamp: ${lines ?? 0};
    line-clamp: ${lines ?? 0};
    display: -webkit-box;
    white-space: ${lines ? 'normal' : 'none'};
    -webkit-box-orient: vertical;`}
`

export default Text
